import React from 'react';
import { 
  HelpCircle, 
  TrendingUp, 
  Minus, 
  Ruler, 
  AlertTriangle, 
  CheckCircle, 
  Thermometer, 
  Droplet 
} from 'lucide-react';

/**
 * Компонент полезных советов и рекомендаций
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Ruler,
      title: 'Выбор диаметра',
      description: 'Для бытового водоснабжения оптимальный диаметр труб: 15-32 мм. Для магистральных линий: 40-100 мм.'
    },
    {
      icon: TrendingUp,
      title: 'Оптимальная скорость',
      description: 'Скорость потока 1-2 м/с - оптимальная для водопроводных систем. Выше 3 м/с - повышенный шум и износ.'
    },
    {
      icon: Minus,
      title: 'Материал труб',
      description: 'Для питьевой воды рекомендуются ПП, ПЭ и медные трубы. Для технической воды подойдут стальные трубы.'
    },
    {
      icon: Thermometer,
      title: 'Температурный режим',
      description: 'При температуре воды > 60°C сокращается срок службы полимерных труб, возрастает вероятность накипи.'
    },
    {
      icon: Droplet,
      title: 'Давление в системе',
      description: 'Нормативное давление в сетях водоснабжения в России: 3-6 бар. Для многоэтажных зданий до 10 бар.'
    },
    {
      icon: AlertTriangle,
      title: 'Предотвращение коррозии',
      description: 'Если в системе используются разные материалы труб, устанавливайте диэлектрические вставки между ними.'
    },
    {
      icon: CheckCircle,
      title: 'Резерв мощности',
      description: 'Закладывайте запас 15-20% при проектировании для компенсации возможного образования отложений со временем.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-blue-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Нормативные документы РФ
            </h4>
            <ul className="text-xs text-blue-600 dark:text-blue-400 space-y-1 list-disc pl-4 mb-3">
              <li>СП 30.13330.2020 "Внутренний водопровод и канализация зданий"</li>
              <li>СП 31.13330.2021 "Водоснабжение. Наружные сети и сооружения"</li>
              <li>СанПиН 2.1.3684-21 "Санитарно-эпидемиологические требования к содержанию территорий..."</li>
              <li>ГОСТ 32415-2013 "Трубы полимерные для водоснабжения. Технические условия"</li>
            </ul>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Получить консультацию специалиста
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;